import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface Packages {
  id: number | null,
  name: string,
  day?: number | null,
  price: number,
  sale_price?: number | null,
  demo?: boolean,
  note?: string,
  pros?: string,
  cons?: string,
  vip?: boolean,
}

export const utilApi = createApi({
  reducerPath: 'utilApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/',
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),

  endpoints: (builder) => ({
    getThemes: builder.query({
      query: () => '/theme'
    }),
    getFields: builder.query({
      query: () => '/field'
    }),
    getCities: builder.query({
      query: () => '/city'
    }),
    getPackages: builder.query({
      query: () => '/package'
    }),
  }),
})

export const { useGetThemesQuery , useGetFieldsQuery , useGetCitiesQuery, useGetPackagesQuery} = utilApi